<template>
	<div class="product">
		<el-row>
			<el-col :span="2">&nbsp;</el-col>
			<el-col :span="20">
				<p class="Title" @click="$router.push({path:'/product'})">产品中心</p>
				<div class="productType">
					<span class="productE" @click="$router.push({path:'/product'})">PRODUCT CENTER</span>
					<div class="type">
						<ul>
							<li @click="getStyle(index,item)" v-for="(item,index) in types" :class="[activeIndex == index?'active':'']" :key="index">
								{{item.name}}&nbsp;&nbsp;
								<!-- <span  v-if="index+1 != types.length">/</span> -->
								&nbsp;&nbsp;
							</li>
						</ul>
					</div>
				</div>
			</el-col>
			<el-col :span="2">&nbsp;</el-col>
		</el-row>
		<el-row>
			<el-col :span="2">&nbsp;</el-col>
			<el-col :span="20">
				<div class="productList">
					<ul>
						<li v-for="(item,index) in productList.slice(0,showL)" @click="goDetails(item.id,name)">
							<div class="productPic">
								<img :src="settings.apiBaseImg+item.image" alt="product" />
							</div>
							<div class="productIntro">
								<p class="productTitle">{{item.name}}</p>
								<!-- <p class="productModel">型号:{{item.xinghao}}</p> -->
								<!-- <p class="productPress hidden-xs-only">
									<span>压力:{{item.pressure}}</span>
									<span>流量:{{item.flow}}</span>
                </p>-->
							</div>
						</li>
					</ul>
				</div>
				<div class="more">
					<button @click="$router.push({path:'/product'})">更多</button>
				</div>
			</el-col>
			<el-col :span="2">&nbsp;</el-col>
		</el-row>
	</div>
</template>

<script>
	import request from "../../assets/js/request.js";
	import qs from "qs";
	export default {
		data() {
			return {
				types: [],
				activeIndex: 0,
				productList: [],
				id: 0,
				name: "",
				showL: 12,
			};
		},
		created() {
			//分类
			this.getType();
			//数据
			this.getData(this.id);
			var sUserAgent = navigator.userAgent;
			if (
				sUserAgent.indexOf("Android") > -1 ||
				sUserAgent.indexOf("iPhone") > -1 ||
				sUserAgent.indexOf("iPad") > -1 ||
				sUserAgent.indexOf("iPod") > -1 ||
				sUserAgent.indexOf("Symbian") > -1
			) {
				this.showL = 8;
			}
		},
		methods: {
			getStyle(index, item) {
				this.activeIndex = index;
				this.name = item.name;
				this.getData(item.id);
			},
			getType() {
				request
					.post(
						this.settings.apiBaseUrl + "/api/index/products_type",
						qs.stringify({}), {
							headers: {},
						}
					)
					.then((res) => {
						if (res.code == 1) {
							this.types = res.data;
							this.name = res.data[0].name;
						} else {
							this.$message.error(res.msg);
						}
					});
			},
			getData(id) {
				request
					.post(
						this.settings.apiBaseUrl + "/api/index/products_list",
						qs.stringify({
							product_type_pid: id,
							product_type_id: "",
						}), {
							headers: {},
						}
					)
					.then((res) => {
						if (res.code == 1) {
							this.productList = res.data.rows;
						} else {
							this.$message.error(res.msg);
						}
					});
			},
			goDetails(id, name) {
				const { href } = this.$router.resolve({
				  path: '/productDetails',
				 query: {
				 	id: id,
				 	name: name
				 }
				});
				window.open(href, "_blank");
				
			}
		},
	};
</script>

<style scoped="scoped">
	.product {
		width: 100%;
		height: auto;
		clear: both;
		padding-bottom: 0px;
	}

	.product /deep/ .el-row {
		width: 100%;
		height: auto;
	}

	.product .Title {
		height: 29px;
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1a1a1a;
		line-height: 18px;
		cursor: pointer;
	}

	.product .productType {
		width: 100%;
		height: 60px;
		cursor: pointer;
	}

	.product .productE {
		width: 14%;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1a1a1a;
		opacity: 0.5;
		display: inline-block;
		line-height: 60px;
	}

	.product .type {
		width: 80%;
		display: inline-block;
	}

	.product /deep/ .el-breadcrumb__item {
		cursor: pointer;
	}

	.product /deep/ .el-breadcrumb__item:hover {
		color: #216bd1;
	}

	.type ul li {
		float: left;

		font-size: 17px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #676767;
		line-height: 25px;
		cursor: pointer;
	}

	.active {
		color: #216bd1 !important;
	}

	.productList {
		width: 100%;
		height: auto;
		margin-top: 80px;
		clear: both;
		overflow: hidden;
	}

	.productList ul li {
		width: 24%;
		height: 404px;
		float: left;
		margin-right: 20px;
		transition: all 0.5s ease;
		cursor: pointer;
		margin-bottom: 50px;
	}

	.productList ul li:nth-child(4n) {
		margin-right: 0;
	}

	.productPic {
		width: 100%;
		height: 80%;
		clear: both;
		position: relative;
		margin: auto;
		overflow: hidden;
	}

	.productPic img {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin-bottom: 20px;
		max-width: 100%;
		margin: auto;
	}

	.productIntro {
		width: 100%;
		height: 20%;
		padding-left: 10px;
		transition: all 0.5s ease;
	}

	.productIntro .productTitle {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #252525;
		line-height: 29px;
		padding: 20px 0 15px 0;
	}

	.productIntro .productModel {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #7f7f7f;
		line-height: 21px;
	}

	.productPress {
		width: 100%;
		height: auto;
	}

	.productPress span {
		width: 45%;
		display: inline-block;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #7f7f7f;
		line-height: 21px;
	}

	.productList ul li:hover {
		background-color: #ffffff;
		box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
	}

	.productList ul li:hover .productIntro {
		background-color: #216bd1;
	}

	.productList ul li:hover .productTitle {
		color: #ffffff;
	}

	.productList ul li:hover .productModel {
		color: #ffffff;
	}

	.productList ul li:hover .productPress span {
		color: #ffffff;
	}

	.more {
		width: 100%;
		height: auto;
		text-align: center;
		margin-top: 0;
		margin-bottom: 50px;
	}

	.more button {
		width: 205px;
		height: 50px;
		background: #ffffff;
		border: 1px solid #216bd1;
		border-radius: 5px;

		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #216bd1;
		line-height: 19px;
	}

	@media screen and (max-width: 750px) {
		.productPic {
			width: 100%;
			height: 70%;
			clear: both;
		}

		.productPic img {
			width: 100%;
			height: 100%;
		}

		.productIntro {
			width: 100%;
			height: 30%;
			padding-left: 10px;
			transition: all 0.5s ease;
			background-color: #e5e5e5;
		}

		.productList ul li {
			width: 45%;
			height: 800px;
			float: left;
			margin-right: 10px;
			transition: all 0.5s ease;
			cursor: pointer;
			margin-bottom: 50px;
		}

		.productList ul li:nth-child(2n) {
			margin-left: 20px;
		}

		.type ul li {
			float: left;
			font-size: 0.2rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #676767;
			line-height: 0.4rem;
		}

		.productIntro .productTitle {
			font-size: 0.25rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #252525;
			line-height: 0.3rem;
			padding: 40px 0 15px 0;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		.productIntro .productModel {
			font-size: 0.2rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #7f7f7f;
			line-height: 0.4rem;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		.productPress {
			width: 100%;
			height: auto;
		}

		.productPress span {
			width: 100%;
			display: block;
			font-size: 0.2rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #7f7f7f;
			line-height: 0.3rem;
		}

		.product .Title {
			font-weight: bold;
			height: 29px;
			font-size: 0.25rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #1a1a1a;
			line-height: 0.1rem;
			cursor: pointer;
			color: #216bd1;
			text-align: center;
		}

		.product .productE {
			width: 100%;
			font-size: 0.25rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #1a1a1a;
			opacity: 0.5;
			display: inline-block;
			line-height: 0.3rem;
			text-align: center;
		}

		.product .type {
			width: 100%;
			display: inline-block;
			margin-top: 20px;
			display: none;
		}

		.product .productType {
			width: 100%;
			height: auto;
			cursor: pointer;
			margin-top: 10px;
		}

		.more button {
			width: 2rem;
			height: 0.5rem;
			background: #ffffff;
			border: 1px solid #216bd1;
			border-radius: 5px;

			font-size: 0.2rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #216bd1;
			line-height: 19px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/product.vue